import { useEffect, useState } from "react";
import { url, validCurrency } from "../utils/config";
import Input from "../reusable_components/Input";
import Select from "../reusable_components/Select";
import postData from "../custom_functions/postData";
import { toast } from "react-toastify";
import patchData from "../custom_functions/patchData";
import currency from "../utils/currency";
import Button from "../reusable_components/Button";
import { btnCancel, btnOne, inputStyle, label, modalContainer, modalTitle } from "../utils/style";



function AddMaterialList({ materialData, setMaterialData, setShowModal, reload }) {
    const [formData, setFormData] = useState({});
    const [missingFields, setMissingFields] = useState([]);
    const [inputErrors, setInputErrors] = useState([]);
    const [showInputError, setShowInputError] = useState(false);

    const requiredFields = ['name', 'cost', 'estimatedTime', 'costType', 'currency'];
    const costType = ['Fixed', 'Hourly'];

    useEffect(() => {
        console.log(materialData)
        if (materialData) {
            setFormData(materialData)
        }
    }, [])

    async function updateResource() {
        if (
            formData.name && formData.name.length > 0 &&
            formData.cost && +formData.cost > 0 &&
            formData.estimatedTime && +formData.estimatedTime > 0 &&
            formData.costType && costType.includes(formData.costType) &&
            formData.currency && currency.includes(formData.currency) &&
            !inputErrors.includes('error')
        ) {
            patchData(`${url}/services/material_list/${formData.id}`, formData, (error => {
                toast.error(error.response.data.message, { autoClose: 3000 })
                setMaterialData()
            }), (data) => {
                toast.success(data.message, { autoClose: 3000 })
                setMaterialData()
                setShowModal(false)
                reload(1 + Math.random())

            })
        } else {
            let fields = Object.keys(formData);
            let miss = [];
            if (fields.length !== requiredFields.length) {
                requiredFields.forEach(field => {
                    if (!fields.includes(field)) {
                        miss.push(field)
                    }
                    if (field.name === 'currency' && !validCurrency.includes(formData[field.name])) {
                        miss.push(field)
                    }
                })
            };
            setMissingFields(miss);
            setShowInputError(true)
        }
    }

    async function addResource() {
        if (
            formData.name && formData.name.length > 0 &&
            formData.cost && +formData.cost > 0 &&
            formData.estimatedTime && +formData.estimatedTime > 0 &&
            formData.costType && costType.includes(formData.costType) &&
            formData.currency && currency.includes(formData.currency) &&
            !inputErrors.includes('error')
        ) {
            postData(`${url}/services/material_list`, formData, (error => {
                toast.error(error.response.data.message, { autoClose: 3000 })
            }), (data) => {
                toast.success(data.message, { autoClose: 3000 })
                setShowModal(false)
                reload(1 + Math.random())
            })
        } else {
            let fields = Object.keys(formData);
            let miss = [];
            if (fields.length !== requiredFields.length) {
                requiredFields.forEach(field => {
                    if (!fields.includes(field)) {
                        miss.push(field)
                    }
                })
            };
            setMissingFields(miss);
            setShowInputError(true)
        }
    }

    function updateFormData(e) {
        const { name, value } = e.target;
        var data = { ...formData };
        data[name] = value;
        setFormData(data);
    }

    return (
        <div className={modalContainer}>
            <div className="bg-white p-4 w-2/3 rounded-lg">
                <div className={modalTitle}>Add New Material</div>
                <div>
                    <div className="grid grid-cols-6 gap-4 py-1 px-2 mt-4">
                        <div className={label}>Material Name</div>
                        <div className="col-span-2">
                            <Input
                                index={0}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                className={inputStyle}
                                name='name'
                                type='text'
                                placeHolder='Enter Material Name'
                                value={formData.name}
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <div className={label}>Material Cost</div>
                        <div className="col-span-2">
                            <Input
                                index={1}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                className={inputStyle}
                                name='cost'
                                type='number'
                                min={0}
                                placeHolder='Enter Material Cost'
                                value={formData.cost}
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-6 gap-4 py-1 px-2">
                        <div className={label}>Estimated Time (mins)</div>
                        <div className="col-span-2">
                            <Input
                                index={1}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                className={inputStyle}
                                name='estimatedTime'
                                type='number'
                                min={0}
                                placeHolder='Enter Estimated Time'
                                value={formData.estimatedTime}
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <div className={label}>Cost Type</div>
                        <div className="col-span-2">
                            <Select
                                testId={'costType'}
                                index={1}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                options={costType}
                                className={inputStyle}
                                name='costType'
                                placeHolder='Cost Type'
                                value={formData.costType}
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-6 gap-4 py-1 px-2 mt-4">
                        <div className={label}>Currency</div>
                        <div className="col-span-2">
                            <Select
                                testId={'currency'}
                                index={1}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                options={currency}
                                className={inputStyle}
                                name='currency'
                                placeHolder='Currency'
                                validCurrency={validCurrency}
                                value={formData.currency}
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>
                </div>
                <div className="flex justify-between py-3 px-32 gap-8">
                    <button onClick={e => setShowModal(false)} className={btnCancel}>Cancel</button>
                    <Button clickHandler={() => { materialData ? updateResource() : addResource() }} className={btnOne} name={'Submit'} />
                </div>
                <div className="text-red-500 font-semibold text-center">
                    {
                        showInputError && 'Please fill all the fields as directed!'
                    }
                </div>
            </div>
        </div>
    )
}

export default AddMaterialList;